import Dropdown from 'react-bootstrap/Dropdown';

function Languages() {

	var detectedLanguage = (window.location.pathname.split('/')[1] == "") ? "en" : window.location.pathname.split('/')[1];
	if(detectedLanguage.length > 2) {
		detectedLanguage = "en";
	}
	const languages = ["en", "de", "it", "fr"];

	function newHref(lang) {
		const path = window.location.pathname;
		console.log(path);
		var newPath = "";
		if(path == "/") {
			newPath = "/" + lang;
		} else {
			newPath = path.replace(detectedLanguage, lang);
			if(newPath == "/en") {
				newPath = "/";
			}
		}
		return newPath;
	}

    return (
        <Dropdown>
            <Dropdown.Toggle variant="tiles" id="dropdown-basic" className="languagesDropdown">
                <img src={"/images/flags/" + detectedLanguage + ".svg"}/>
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdownMenu">
                 {languages.map(lang => (
                    (lang != detectedLanguage) &&
                    <Dropdown.Item key={lang} href={newHref(lang)}>
		                <img src={"/images/flags/" + lang + ".svg"}/>
		            </Dropdown.Item>

		        ))}

		    </Dropdown.Menu>
        </Dropdown>
    );
}

export default Languages;